import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, Column } from 'src/core/ui/data-table.view';

interface UserListViewProps extends ComponentViewProps<DataSet<UserSummary>> {
	onItemDoubleClicked?: (item: UserSummary) => void;
}

export class UserListView extends React.Component<UserListViewProps, {}> {
	constructor(props: Readonly<UserListViewProps>) {
		super(props);
	}

	columns: Column[] = [
		{
			key: 'userName',
			title: 'User name',
			dataIndex: 'userName',
			render: (text, record: UserSummary) => <Link to={`/general/users/${record.id}`}>{text}</Link>,
		},
		{
			key: 'displayName',
			title: 'Name',
			dataIndex: 'displayName'
		},
		{
			key: 'email',
			title: 'Email',
			dataIndex: 'notificationEmail'
		},
		{
			key: 'roles',
			title: 'Roles',
			dataIndex: 'roles'
		},
		{
			key: 'createdOn',
			title: 'Created on',
			dataIndex: 'createdOn',
			render: (text: Date, record: UserSummary) => record.createdOn.toDateString()
		}
	];

	render(): JSX.Element {
		const { model } = this.props;

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						model={model}
						columns={this.columns}
						setBusy={this.props.setBusy}
						itemDoubleClick={(item) => {
							if (this.props.onItemDoubleClicked) {
								this.props.onItemDoubleClicked(item);
							}
						}}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/list/user-list.view.tsx